// extracted by mini-css-extract-plugin
export default {"loader_container":"LoaderInline_loader_container__U50mA","loader_spinner":"LoaderInline_loader_spinner__QgLyb","spin":"LoaderInline_spin__wYI-m"};